<script setup lang="ts">import { $socket } from "@client/lib/socket";import { useGameStore as ___useGameStore } from "@client/stores"; const $$game =  ___useGameStore();
import { CheckIcon, XIcon } from "lucide-vue-next";
function handleAccept() {
	const isInvitation = true;
	$socket.game.emit("userAccepted", isInvitation);
	$$game.players.user.flags.hasAccepted = true;
	$$game.players.user.flags.isInvited = false;
}

function handleLeaveOrDecline() {
	$socket.game.emit("userDeclined");
	$$game["~resetEverything"]();
}
</script>
<template>
	<Transition name="invited-toast" appear>
		<div
			class="tw:flex tw:flex-col tw:gap-2 tw:w-full tw:flex-1 tw:p-4 tw:font-bold tw:grow-0 tw:bg-[#252525]">
			<p
				class="tw:[text-shadow:2px_2px_#000] tw:text-[max(0.7rem,1vmax)] tw:truncate tw:text-[--accent-color]">
				GAME INVITE
			</p>
			<div class="tw:w-full tw:items-center tw:flex">
				<div
					class="tw:flex tw:flex-1 tw:gap-3 tw:items-center tw:justify-center tw:flex-wrap">
					<img
						alt="friend-logo"
						:src="$$game.players?.opponent.info?.avatarUrl!"
						class="tw:h-[max(22px,2.5vmax)] animation-pulse tw:flex-shrink-0 tw:rounded-full tw:aspect-square
							tw:object-cover" />
					<div
						class="tw:flex tw:flex-col tw:w-[55%] tw:text-[max(0.6rem,0.7vmax)]
							tw:[text-shadow:1px_1px_rgba(0,0,0,0.8)]">
						<p class="tw:font-bold tw:truncate">
							{{ $$game.players?.opponent.info.username }}
						</p>
						<p class="tw:text-[#aaaaaa] tw:truncate">UNRANKED</p>
					</div>
				</div>
				<div class="tw:flex tw:h-full tw:items-center tw:gap-2 tw:flex-wrap">
					<v-btn
						class="tw:hover:scale-125 tw:!rounded-full"
						variant="outlined"
						title="Accept"
						:size="20"
						@click="handleAccept">
						<CheckIcon class="tw:!rounded-full" :size="16" />
					</v-btn>
					<v-btn
						class="tw:hover:scale-125 tw:!rounded-full"
						variant="outlined"
						:size="20"
						title="Decline"
						@click="handleLeaveOrDecline">
						<XIcon :size="16" />
					</v-btn>
				</div>
			</div>
		</div>
	</Transition>
</template>
<style scoped>
.invited-toast-enter-active,
.invited-toast-leave-active {
	transition: all 10s ease;
}

.invited-toast-enter-from,
.invited-toast-leave-to {
	opacity: 0;
	transform: translateX(100px);
}

.animation-pulse {
	animation: pulse 2s infinite;
}
@keyframes pulse {
	0% {
		transform: scale(0.8);
		filter: drop-shadow(0 0 rgb(160, 0, 210));
	}
	70% {
		transform: scale(1);
		filter: drop-shadow(0px 8px 1mm rgba(229, 62, 62, 0));
	}
	100% {
		transform: scale(0.8);
	}
}
</style>
